export const FETCH_PICTURES = 'FETCH_PICTURES'
export const UPDATE_PICTURES = 'UPDATE_PICTURES'
export const UPLOAD_PICTURES = 'UPLOAD_PICTURES'
export const DELETE_PICTURES = 'DELETE_PICTURES'
export const CONFIRM_PART_PICTURES_UPLOAD = 'CONFIRM_PART_PICTURES_UPLOAD'
